export enum EnumSituacaoPlano {
    Desativado = 0,
    Ativado = 1
}